import React from "react";
import styles from "./SingleImageSlider.module.scss";
import { ImageType } from "@/types/baseTypes";
import { MediaItem } from "@/components/MediaItem/MediaItem";
import { MediaFormatType } from "@/types/ModuleOptionsType";
import { useCarouselExtraContext } from "@/context/CarouselExtraContext";

function SingleImageSliderElement({
  image,
  show_card_box,
  show_border_radius,
  show_box_shadow,
  image_keep_ratio,
  media_format,
  index,
}: {
  image: false | ImageType;
  show_card_box: boolean;
  show_border_radius: boolean;
  show_box_shadow: boolean;
  image_keep_ratio: boolean;
  media_format: MediaFormatType;
  index: number;
}) {
  const { activeIndex, isUltrahd } = useCarouselExtraContext();
  const isActive = activeIndex === index;
  return (
    <article
      className={`slide-card ${styles["carousel-item-content"]} is-flex is-flex-direction-column ${show_card_box ? "is-box" : ""} ${show_border_radius && show_card_box ? "has-border-radius" : ""} ${show_box_shadow && show_card_box ? "has-box-shadow" : ""} ${show_card_box && image_keep_ratio ? "p-3" : ""} ${isActive ? styles["active"] : ""}`}
      data-ultrahd={isUltrahd}
    >
      {image && (
        <MediaItem
          image_desktop={image}
          sizes="100%"
          priority={true}
          mediaFormat={image_keep_ratio ? undefined : media_format}
          objectFit={image_keep_ratio ? "contain" : "cover"}
          className="has-border-radius is-clipped"
        />
      )}
      {/* {caption && (
        <p
          //   ref={(el) => {
          //     {
          //       captionRefs.current[index] = el;
          //     }
          //   }}
          className={`${styles["image-caption"]} ${image_keep_ratio ? "pt-3" : "p-3"}`}
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      )} */}
    </article>
  );
}

export default SingleImageSliderElement;
